import React from "react";
import { Box, Typography, CardContent, LinearProgress } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { TransitionRecordStatsDto } from "../../../shared/dtos/transitionRecord/TransitionRecordStatsDto";

interface TransitionRecordWidgetProps {
  data: TransitionRecordStatsDto;
}

interface StatusItem {
  label: string;
  value: number;
  color: "success" | "info" | "warning" | "error";
}

const TransitionRecordWidget: React.FC<TransitionRecordWidgetProps> = ({
  data,
}) => {
  const meta = getEntityMeta("TRANSITION_RECORD");
  const Icon = meta.icon;

  const statuses: StatusItem[] = [
    { label: "Promoted", value: data.promoted, color: "success" },
    { label: "Graduated", value: data.graduated, color: "info" },
    { label: "Repeated", value: data.repeated, color: "warning" },
    { label: "Transferred Out", value: data.transferredOut, color: "error" },
  ];

  const safeTotal = data.total || 1;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {meta.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Total Records: {data.total}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {statuses.map((s, index) => (
            <Box key={index}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0.5,
                }}
              >
                <Typography variant="body2">{s.label}</Typography>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {s.value}
                </Typography>
              </Box>
              <LinearProgress
                variant="determinate"
                value={(s.value / safeTotal) * 100}
                color={s.color}
                sx={{ height: 6, borderRadius: 3 }}
              />
            </Box>
          ))}
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default TransitionRecordWidget;
